const spanTypes = [
  'a', 'b', 'bdo', 'big', 'em', 'font', 'i', 'kbd', 'q', 'samp', // ignore spelling
  'small', 'span', 'strong', 'sub', 'sup', 'time', 'tt', 'u', 'var' // ignore spelling
];
const metaTypes = ['title', 'meta', 'style', 'script'];
const structureTypes = ['table', 'ul', 'ol', 'dt', 'dd'];

export { spanTypes, metaTypes, structureTypes };
